import { all } from "redux-saga/effects";
import loginSaga from "./authSagas/loginSaga";
import influencerListSaga from "./influencerSagas/influencerListSaga";
import brandListSaga from "./brandSagas/brandListSaga";
import approvedRejectedInfluencerSaga from "./influencerSagas/approvedRejectedInfluencerSaga";
import {approvedRejectedBrand} from "../actions/brandActions/approvedRejectedBrandActions";
import approvedRejectedBrandSaga from "./brandSagas/approvedRejectedBrandSaga";
import campaignListSaga from "./campaignSagas/campaignListSaga";
import approvedRejectedCampaignSaga from "./campaignSagas/approvedRejectedCampaignSaga";
import campaignByIdSaga from "./campaignSagas/campaignByIdSaga";
import rateCardListSaga from "./rateCardSagas/rateCardListSagas";
import rateCardCreateSaga from "./rateCardSagas/rateCardCreateSagas";
import rateCardUpdateSaga from "./rateCardSagas/rateCardUpdateSagas";
import configPropertyListSaga from "./configPropertySagas/configPropertyListSaga";
import configPropertyUpdateSaga from "./configPropertySagas/configPropertyUpdateSaga";
import getAllNicheListSaga from "./publicSagas/getAllNicheSaga";
import getAllRegionListSaga from "./publicSagas/getAllRegionsSaga";
import getAllStateListSaga from "./publicSagas/getAllStateSaga";
import getAllAgeGroupListSaga from "./publicSagas/getAllAgeGroupSaga";
import getAllCountryListSaga from "./publicSagas/getAllCountrySaga";
import userListFilterSaga from "./userSagas/userListSaga"
import markUserStatusSaga from "./userSagas/markUserStatusSaga"
import campaignListForDisabledSaga from "./campaignSagas/campaignListForMarkDisabledSaga"
import markActiveInActiveCampaignSaga from "./campaignSagas/markActiveInActiveCampaignSaga"
import manualContentListSaga from "./manualVerificationSagas/manualContentListSaga"
import videoIdApprovalActionByAdminSaga from "./manualVerificationSagas/videoIdApprovalActionByAdminSaga";
import downloadContentForManualMatchSaga from "./manualVerificationSagas/downloadContentForManualMatchSaga";
import getAgencyListByStatusSaga from "./agencySagas/getAgencyListByStatusSaga";
import markApprovedRejectedAgencySaga from "./agencySagas/markApprovedRejectedAgencySaga";

// import generateOtpSaga from "./authSagas/generateOtpSaga";

export default function* rootSaga() {
    yield all([
        // generateOtpSaga(),
        loginSaga(),
        influencerListSaga(),
        getAgencyListByStatusSaga(),
        brandListSaga(),
        approvedRejectedInfluencerSaga(),
        approvedRejectedBrandSaga(),
        campaignListSaga(),
        approvedRejectedCampaignSaga(),
        campaignByIdSaga(),
        rateCardListSaga(),
        rateCardCreateSaga(),
        rateCardUpdateSaga(),
        configPropertyListSaga(),
        configPropertyUpdateSaga(),
        getAllNicheListSaga(),
        getAllRegionListSaga(),
        getAllStateListSaga(),
        getAllAgeGroupListSaga(),
        getAllCountryListSaga(),
        userListFilterSaga(),
        markUserStatusSaga(),
        campaignListForDisabledSaga(),
        markActiveInActiveCampaignSaga(),
        manualContentListSaga(),
        videoIdApprovalActionByAdminSaga(),
        downloadContentForManualMatchSaga(),
        markApprovedRejectedAgencySaga()
    ])
}
